import { Button, Card } from 'antd'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { ADMINISTRATION_PAGE_UI_STATES } from '../../../statics/constants'
import { CheckCircleFilled, CloseCircleFilled, ArrowLeftOutlined } from '@ant-design/icons'
import { setProjectProperties } from '../../../store/actions'

const ActionResult = ({
  action,
  type,
  resetAdministrationPage,
  setCurrentUIState,
  destinationProjectId,
  sourceProjectName,
  destinationProjectName,
  entity,
}) => {
  const history = useHistory()
  const dispatch = useDispatch()

  const successActionVerb = action === 'Clone' ? 'cloned' : action
  const failureActionVerb = action === 'Clone' ? 'cloning' : action

  return (
    <>
      <Card
        className='shadow-sm col-span-1'
        title={
          <div className='flex items-center'>
            {type === 'success' ? (
              <>
                Success <CheckCircleFilled className='ml-2' style={{ color: '#52c41a' }} />
              </>
            ) : (
              <>
                Fail <CloseCircleFilled className='ml-2' style={{ color: '#ff4d4f' }} />
              </>
            )}
          </div>
        }
        headStyle={{ backgroundColor: 'var(--transparent-color)', fontWeight: 'bold' }}
      >
        {type === 'success' ? (
          <>
            {entity === 'Component' ? (
              <p>
                Cloning complete! View your cloned components now in useMango's '
                <span className='font-semibold'>Components</span>' section.
              </p>
            ) : (
              <>
                <p>
                  The {entity}(s) has been successfully {successActionVerb} to the designated project.
                </p>
                <p>
                  <span
                    to=''
                    onClick={() => {
                      dispatch(setProjectProperties({ projectName: destinationProjectName }))
                      history.push(`/p/${destinationProjectId}/tests`)
                    }}
                    className='text-blue-500 cursor-pointer hover:text-blue-400'
                  >
                    Click here
                  </span>{' '}
                  to see the {successActionVerb} {entity}
                  (s).
                </p>
              </>
            )}
          </>
        ) : (
          <p>
            An unexpected error occurred while {failureActionVerb} the {entity}(s) from{' '}
            <span className='font-bold italic mr-1'>{sourceProjectName}</span> to{' '}
            <span className='font-bold italic'>{destinationProjectName}</span>.
          </p>
        )}
      </Card>
      <div className='flex items-center gap-x-6 w-full justify-end'>
        {type === 'fail' && (
          <Button
            className='w-min my-6'
            type='primary'
            onClick={() => setCurrentUIState(ADMINISTRATION_PAGE_UI_STATES.SUMMARY)}
          >
            <ArrowLeftOutlined /> Back
          </Button>
        )}
        <Button className='w-min my-6' type='primary' onClick={() => resetAdministrationPage()}>
          Finish
        </Button>
      </div>
    </>
  )
}

export default ActionResult
